module.exports = __webpack_public_path__ + "img/bell.e48d8b37.svg";